import React from 'react';

import { Route, Routes } from 'react-router-dom';

import AccountList from './AccountList';
import AccountProfile from './AccountProfile';
import CreateAccount from './CreateAccount';

const Main: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<AccountList />} />
      <Route path=":accountId/*" element={<AccountProfile />} />
      <Route path="create" element={<CreateAccount />} />
    </Routes>
  );
};

export default Main;
